module.exports = __webpack_public_path__ + "img/kv.41c6dfc1.png";